<template>
  <div>
    <div class="page-header pr-0">
      <h2><a href="/dashboard"><i class="fas fa-tachometer-alt"></i></a></h2>
      <ol class="breadcrumbs">
          <li class="active"><span>Pagos</span></li>
      </ol>
      <div class="right-wrapper pull-right">
          <template>
              <a type="button" class="btn btn-custom btn-sm  mt-2 mr-2" href="/cuenta/configuration"><i class="fas fa-cogs"></i> Configuración</a>
          </template>
      </div>
    </div>
    <div class="card">
      <div class="card-header bg-info">
        <h3 class="my-0">Listado de Pagos</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col"></div>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr width="100%">
                <th width="5%">#</th>
                <th>Fecha de pago</th>
                <th>Fecha real de pago</th>
                <th>Concepto</th>
                <!-- <th>Referencia Metodo Pago</th> -->
                <th class="text-center">Monto</th>
                <th class="text-center">Estado</th>
                <th class="text-center">Acciones</th>
                <th class="text-center">Subir pago</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in records">
                <td>{{ index + 1 }}</td>
                <td>{{ row.date_of_payment }}</td>
                <td>{{ row.date_of_payment_real }}</td>
                <td>{{ row.comentario }}</td>
               <!-- <td>{{ row.reference_payment }}</td> -->
                <td class="text-center">{{ row.payment }}</td>
                <td class="text-center">{{ row.state_description }}</td>
                <td class="text-center">
                  <button
                    v-if="row.state === 'E' || row.state === 'V'"
                    type="button"
                    class="btn waves-effect waves-light btn-xs btn-info"
                    @click.prevent="clickPayment(row.id, row.payment)"
                  >Pagar</button>
                  <!--<span v-else>Pagado</span> -->
                </td>
                <td>
                  <template v-if="row.file">
                    <div class="d-flex align-items-center">
                      <el-button type="success" plain
                          size="small"
                          round
                          @click="donwloadFile(row.id)"
                      >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 11.5V20m0 0l3-3m-3 3l-3-3M8 7.036a3.5 3.5 0 0 1 1.975.99M17.5 14c1.519 0 2.5-1.231 2.5-2.75a2.75 2.75 0 0 0-2.016-2.65A5 5 0 0 0 8.37 7.108a3.5 3.5 0 0 0-1.87 6.746"/></svg>
                      </el-button>
                    </div>
                  </template>
                  <template v-else>
                    <el-upload
                      class="upload-demo"
                      :headers="headers"
                      :action="`/${resource}/upload-direct`"
                      :data="{'id': row.id, 'client_payment_id': row.reference_id}"
                      :multiple="false"
                      :limit="1"
                      :on-success="successUploadDirect"
                      :show-file-list="false"
                    >
                        <el-button
                            slot="trigger" size="small"
                            type="primary"
                        >
                            Seleccionar archivo
                        </el-button>
                        <div slot="tip" class="el-upload__tip" v-if="row.file">
                            Un archivo cargado
                        </div>
                    </el-upload>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

export default {
  data() {
    return {
      showDialog: false,
      resource: "cuenta",
      recordId: null,
      records: [],
      culqi_: {},
      headers: headers_token,
    };
  },
  created() {
    this.getData();
  },
  mounted() {

  },
  methods: {
    demo() {

    },
    getData() {
      this.$http.get(`/${this.resource}/payment_records`).then(response => {
        this.records = response.data.data;
      });
    },
    clickPayment(id, payment) {
      window.execCulqi(id, payment)

    },
    async donwloadFile(id) {
      window.open(`/${this.resource}/download/${id}`, '_blank')
    },

    successUploadDirect(response) {
      if (response.success) {
        this.$message.success(response.message)
        this.getData()
      } else {
        this.$message.error(response.message)
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/views/tenant/account/payment_index.vue